import warning from '../../../assets/header/warning.svg';
import calculator from '../../../assets/header/calculator.svg';
import BarekamButton, { HeaderButtons } from '../../components/button';
import BarekamText from "../../components/text";
import { ButtonType } from "./header-button.enum";
import { useNavigate } from "react-router-dom";
import AddressButton from "./addresses-button/address-button";
import Message from "../../components/message";
import { MessageSections } from "../../components/message/message";
import LanguageButton from "./language-button/language-button";
import WalletButton from "./wallet-button/wallet-button";
import UserButton from "./user-button/user-button";
import NotificationsButton from "./notifications-button/notifications-button";
import { GapContainer } from "../../components/card/styled";

const HeaderButtonsRow = ({
    withUserData,
    isDesktop,
    isTablet,
    isAdmin,
    isWarehouseWorker,
    hasValidatedRecipient,
    isPdr
}: HeaderButtonsRowProps) => {
    const navigate = useNavigate();
    const locale = location.pathname.split("/")[1];
    
    function handleButtonClick(button: ButtonType) {
        switch (button) {
            case ButtonType.PROHIBITED_ITEMS:
                window.open(`https://online.barekam.am/${locale}/?scrollTo=prohibited`, '_blank', 'rel=noopener noreferrer');
                break;
            case ButtonType.CALCULATE:
                if (isAdmin || isWarehouseWorker) {
                    navigate('management/calculate')
                } else {
                    navigate('orders/calculate')
                }
                break;
        }
    }

    if (isDesktop || isTablet) {
        return (
            <GapContainer>
                {withUserData && !isWarehouseWorker && !isPdr
                    ? <>
                        <BarekamButton type={HeaderButtons.SIMPLE}
                            onClick={() => handleButtonClick(ButtonType.PROHIBITED_ITEMS)}
                            key={'prohibited-items'}>
                            <img src={warning} alt={""} />
                            <BarekamText variant={"header"} bold>
                                <Message messageKey={'prohibited_items'} sectionId={MessageSections.MAIN} />
                            </BarekamText>
                        </BarekamButton>

                        {(!isAdmin && !isWarehouseWorker && !isPdr) && (
                            <BarekamButton type={HeaderButtons.SIMPLE}
                                onClick={() => handleButtonClick(ButtonType.CALCULATE)}
                                key={'calculate-button'}>
                                <img src={calculator} alt={""} />
                                <BarekamText variant={"header"} bold>
                                    <Message messageKey={'calculate'} sectionId={MessageSections.MAIN} />
                                </BarekamText>
                            </BarekamButton>
                        )}
                    </>
                    : <></>
                }

                <LanguageButton isDesktop={isDesktop || isTablet} key={'language-button'} />

                {withUserData
                    ? <>
                        {!isWarehouseWorker && !isAdmin && !isPdr
                            ? <>
                                <WalletButton key={'wallet-button'} isDesktop={isDesktop} isTablet={isTablet} hasValidatedRecipient={hasValidatedRecipient} />
                                <AddressButton hasValidatedRecipient={true} key={'address-button'} />
                            </>
                            : ''
                        }

                        <NotificationsButton key={'notifications-button'} isDesktop={isDesktop || isTablet} />

                        <UserButton 
                            isAdmin={isAdmin}
                            isWarehouseWorker={isWarehouseWorker}
                            isPdr={isPdr}
                            hasValidatedRecipient={hasValidatedRecipient}
                            isDesktop={isDesktop}
                            isTablet={isTablet}
                            key={'user-button'} 
                        />
                    </>
                    : <></>
                }

            </GapContainer>
        )
    } else {
        return (
            <GapContainer>
                {withUserData
                    ? <>
                        <BarekamButton type={HeaderButtons.SIMPLE}
                            onClick={() => handleButtonClick(ButtonType.PROHIBITED_ITEMS)}
                            key={'prohibited-items'}>
                            <img src={warning} alt={""} />
                        </BarekamButton>

                        {(!isAdmin && !isWarehouseWorker && !isPdr) && (
                            <BarekamButton type={HeaderButtons.SIMPLE}
                                onClick={() => handleButtonClick(ButtonType.CALCULATE)}
                                key={'calculate-button'}>
                                <img src={calculator} alt={""} />
                            </BarekamButton>
                        )}

                        <LanguageButton isDesktop={isDesktop} key={'language-button'} />

                        <NotificationsButton key={'notifications-button'} isDesktop={isDesktop} />

                        <UserButton isAdmin={isAdmin}
                            isWarehouseWorker={isWarehouseWorker}
                            hasValidatedRecipient={hasValidatedRecipient}
                            isDesktop={isDesktop}
                            isTablet={isTablet}
                            isPdr={isPdr}
                            key={'user-button'} />
                    </>
                    : <>
                        <LanguageButton isDesktop={isDesktop} key={'language-button'} />
                    </>
                }
            </GapContainer>
        )
    }
};

export default HeaderButtonsRow;

export interface HeaderButtonsRowProps {
    withUserData: boolean,
    isDesktop: boolean,
    isTablet: boolean,
    isAdmin: boolean,
    isWarehouseWorker: boolean,
    isPdr: boolean,
    hasValidatedRecipient: boolean,
}
